import React from 'react';
import { IFieldState } from './MakeField';
import useContext from '../../../../hooks/useContext';
import { TFireEvent, TSetError, TSetValue } from './types';

export type TFieldContext<ValueType = unknown> = {
  doFocus: (cb: () => void) => void;
  fireEvent: TFireEvent;
  isReadonly: boolean;
  markAsLoaded: () => void;
  setError: TSetError;
  setValue: TSetValue;
  state: IFieldState<ValueType> & { value: ValueType };
  props?: {
    message?: string | null;
    readOnly?: boolean;
    readonly?: boolean;
    disabled?: boolean;
    visibilityHidden?: boolean;
    formDataReadOnly?: boolean;
    value: unknown;
    required?: boolean;
  };
};
export type THooksContext = Omit<
  TFieldContext,
  'fireEvent' | 'doFocus' | 'markAsLoaded'
> & {
  focus: () => void;
};

const FieldContext = React.createContext<TFieldContext | undefined>(undefined);
FieldContext.displayName = 'FieldContext';

export function useFieldContext<ValueType = unknown>() {
  const context = useContext(FieldContext);

  return context as unknown as TFieldContext<ValueType>;
}

export default FieldContext;
